import React from 'react';
import ConfirmationModal from '../../Common/ConfirmationModal';

/**
 * Event-module confirmation. Single dialog by default.
 * Pass `doubleConfirm` only for irreversible flows that still need two steps.
 */
const EventConfirmationModal = ({ doubleConfirm = false, ...props }) => (
  <ConfirmationModal doubleConfirm={doubleConfirm} {...props} />
);

export default EventConfirmationModal;
